// Helpers for the customer detail applications view.

export interface LicenseLike {
  install_id?: unknown;
  app_id?: unknown;
  [key: string]: unknown;
}

export interface AppGroup {
  appId: string;
  licenses: LicenseLike[];
}

/**
 * Group license-link rows by their app_id in first-seen order.
 * Rows without an app_id go under 'unknown'. Rows without an install_id
 * are kept (the UI renders them with an "unknown install" label).
 */
export function groupLicensesByApp(licenses: LicenseLike[] | null | undefined): AppGroup[] {
  const groups = new Map<string, LicenseLike[]>();
  for (const license of licenses ?? []) {
    if (!license || typeof license !== 'object') continue;
    const appId = typeof license.app_id === 'string' && license.app_id ? license.app_id : 'unknown';
    const list = groups.get(appId);
    if (list) list.push(license);
    else groups.set(appId, [license]);
  }
  return [...groups.entries()].map(([appId, groupLicenses]) => ({ appId, licenses: groupLicenses }));
}

/** True when the customer row is marked as a test/sandbox customer. */
export function isTestCustomer(customer: { is_test?: unknown } | null | undefined): boolean {
  const v = customer?.is_test;
  return v === 1 || v === true || v === '1';
}

/** Display name for an app id, falling back to the raw id when unknown. */
export function appDisplayName(appId: string, knownApps?: Array<{ app_id?: unknown; display_name?: unknown }>): string {
  const match = (knownApps ?? []).find((a) => a?.app_id === appId);
  if (match && typeof match.display_name === 'string' && match.display_name) return match.display_name;
  return appId;
}
